// src/utils/runTenantSetup.js
import { setupInitialTenants, assignUserToTenant } from './setupTenants';

/**
 * Run this script to set up initial tenants for HealeHub
 * This should be run once after implementing multi-tenancy
 */
export const runTenantSetup = async () => {
  try {
    console.log('🚀 Starting HealeHub Multi-Tenant Setup...');
    
    // Step 1: Create initial tenants
    console.log('\n📋 Step 1: Creating initial tenants...');
    const tenants = await setupInitialTenants();
    
    if (tenants.length === 0) {
      throw new Error('No tenants were created');
    }

    console.log('\n✅ Tenant setup completed successfully!');
    console.log('\n📊 Summary:');
    tenants.forEach((tenant, index) => {
      console.log(`${index + 1}. ${tenant.name} (ID: ${tenant.id})`);
      console.log(`   - Slug: ${tenant.slug}`);
      console.log(`   - Email: ${tenant.email}`);
      console.log(`   - Treatments: ${tenant.settings?.treatmentTypes?.length || 0}`);
      console.log(`   - Rooms: ${tenant.settings?.rooms?.length || 0}`);
    });

    console.log('\n🎯 Next Steps:');
    console.log('1. Assign users to tenants using assignUserToTenant(userId, tenantId, role)');
    console.log('2. Services already configured to use tenantDataService');
    console.log('3. Test the multi-tenant functionality');
    
    return tenants;
    
  } catch (error) {
    console.error('❌ Error during tenant setup:', error);
    throw error;
  }
};

// Helper function to assign current user to a tenant (for testing)
export const assignCurrentUserToTenant = async (tenantSlug, role = 'admin') => {
  try {
    // This would need to be called with actual user context
    console.log(`👤 To assign current user to ${tenantSlug} as ${role}:`);
    console.log(`assignUserToTenant(currentUser.uid, tenantId, '${role}')`);
    
    // Return instructions for manual assignment
    return {
      instruction: `Use assignUserToTenant(userId, tenantId, '${role}') to assign users to tenants`,
      tenantSlug,
      role
    };
  } catch (error) {
    console.error('❌ Error assigning user to tenant:', error);
    throw error;
  }
};

// Export for console usage
if (typeof window !== 'undefined') {
  window.runTenantSetup = runTenantSetup;
  window.assignCurrentUserToTenant = assignCurrentUserToTenant;
}
